import { FaireDate } from "./FaireDate";
import { FaireDateRange } from "./FaireDateRange";
/** Creates {@link FaireDateRange} for expected ship date(s). */ export var faireDateRangeFromExpectedShipDateRange = function(expectedShipDateRange) {
    if (!expectedShipDateRange.expected_ship_date) {
        return;
    }
    var startDate = getStartDate(expectedShipDateRange.expected_ship_date);
    if (!startDate) {
        return;
    }
    var endDate = getEndDate(startDate, expectedShipDateRange.expected_ship_window_days);
    return new FaireDateRange(startDate, endDate);
};
export var expectedShipDateRangeFromFaireDateRange = function(faireDateRange) {
    return {
        expected_ship_date: faireDateRange.startDate.normalizedUtcTimestamp,
        // Number of days: Number of millis between two dates divided by number of
        // millis in a day.
        expected_ship_window_days: Math.round((faireDateRange.endDate.normalizedUtcTimestamp - faireDateRange.startDate.normalizedUtcTimestamp) / (1000 * 60 * 60 * 24))
    };
};
/**
 * Formats expected ship date(s).
 *
 * This is just a shortcut for calling {@link faireDateRangeFromExpectedShipDateRange}
 * followed by {@link FaireDateRange#format}.
 */ export var formatExpectedShipDateRange = function(expectedShipDateRange) {
    var formatString = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "MMMM d", formatForMultidayString = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : formatString;
    var faireDateRange = faireDateRangeFromExpectedShipDateRange(expectedShipDateRange);
    return faireDateRange ? faireDateRange.format({
        dateFormat: formatString,
        multiDayFormat: formatForMultidayString
    }) : undefined;
};
var getStartDate = function(starDateUtcMillis) {
    return FaireDate.fromNormalizedOrLocalEndOfDayTimestamp(starDateUtcMillis);
};
var getEndDate = function(startDate, days) {
    if (!days) {
        return startDate;
    }
    var localEndDate = new Date(startDate.localDateObject);
    localEndDate.setDate(localEndDate.getDate() + days);
    return FaireDate.fromLocalDateObject(localEndDate);
};
